
export const GET_ALL_USERS = 'get_all_users';
export const USER_STATUS = 'user_status';
export const SET_LANG = 'set_lang';
export function getUser(lang) {
  return dispatch => {
    dispatch({
      type: USER_STATUS,
      payload: lang
    });

  };
}


export function setLang(lang) {
    return dispatch => {
        dispatch({
            type: SET_LANG,
            payload: lang
        });

    };
}








// WEBPACK FOOTER //
// ./src/Actions/UserActions.js